export default "__VITE_ASSET__B5Qnk48___"